import  { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import { selectDbnpListItems } from '../../../../../redux/dbnp/selector';
import { dbnp } from '../../../../../redux/dbnp/action';
import PageLoader from '../../../../../components/PageLoader';
import DbaMappingComponent from '../components/shipx-agency-mapping.component';
import { dbnpRegistries } from '../../../../../redux/dbnp-registries/action';
import { selectDbnpRegistriesListItems } from '../../../../../redux/dbnp-registries/selector';
import { selectGlobalDBARegistriesListItems } from '../../../../../redux/global-dba-registries/selector';
import { globalDBARegistries } from '../../../../../redux/global-dba-registries/action';
import { selectChannelProgramsListItems } from '../../../../../redux/channel-program/selector';
import { channelPrograms } from '../../../../../redux/channel-program/action';
import { selectDodProgramParticipantsListItems } from '../../../../../redux/dod-program-participants/selector';
import { dodProgramParticipants } from '../../../../../redux/dod-program-participants/action';
import { selectShipxMappingQueryItems } from '../../../../../redux/shipx-agency-mappings/selector';
import { shipxAgencyMappings } from '../../../../../redux/shipx-agency-mappings/action';



const ShipXAgencyMapping = () => {   
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const dbnpMappingQuery = useSelector(selectShipxMappingQueryItems)
  const dbnpItems = useSelector(selectDbnpRegistriesListItems)
  const dbnpregistriesItems = useSelector(selectDbnpListItems)
    const dbasItems = useSelector(selectGlobalDBARegistriesListItems)
  const itemsData = useSelector(selectChannelProgramsListItems)
const [isQuery, setIsQuery] = useState<boolean>(false)
const [isLoading, setIsLoading] = useState<boolean>(true)
  const participantsData = useSelector(selectDodProgramParticipantsListItems)
  const [
    selectedDbaMapping,
    setSelectedDbaMapping
  ] = useState<any>({})
 

  const fetchDbnpMappingById= ()=>{
    dispatch(shipxAgencyMappings.query({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/shipx-cloud/shipx-agency-mappings/fetch-detail`,entity:'dbnpMappings',jsonData:{
          
  
      Context:{},
      Records: [
      {
        Id: parmas?.id
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})

  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedDbaMapping({ ...selectedDbaMapping, [field]: event });
  }

  useEffect(
    () => {
        dispatch(dbnpRegistries.list({
                url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/platform-management/dbnp-registries/list`,
                entity: 'dbnpRegistries',
                jsonData: {
                  "Filters": [
                    {
                    "FieldName": "IsProxyNetwork",
                    "FilterOperatorId": 1,
                    "FieldValue": true,
                    "FieldType": "boolean"
                    },
                  ],        
              }})).then(()=>{
                  dispatch(dbnp.list({
                    url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dbnp/list`,
                    entity: 'dbnp',
                    jsonData: {

              
                  }}))}).then(() => {
                      dispatch(channelPrograms.list({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/global-shipx-cloud/global-channel-shipx-programs/fetch`,
      entity: 'channelPrograms',
      jsonData: {
       "Context" :{},
       "Records" :
       [
        {}
       ]
      }
    }))}).then(() => {
        dispatch(dodProgramParticipants.list({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/global-shipx-cloud/global-shipx-program-participants/fetch`,
      entity: 'dodProgramParticipants',
      jsonData: {
       "Context" :{},
       "Records" :
       [
        {}
       ],
        Pagination:{
      }
      }
    }))}).then(() => {

            if (parmas?.id > 0) {
                fetchDbnpMappingById()
                setIsLoading(false)
              }else {
                setIsLoading(false)
              }
           
          })
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedDbaMapping(dbnpMappingQuery?.result?.items)
      }
    },
    [isQuery]
  )
 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      await dispatch(shipxAgencyMappings.resetAction({ actionType: 'update' }))
      await dispatch(shipxAgencyMappings.update({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/shipx-cloud/shipx-agency-mappings`,entity:'dbnpMappings',jsonData:{   
    "Context": {},    
    "Records": [
        selectedDbaMapping
    ]
}})).then(()=>{
    back()
  })
  

    }else{
      await dispatch(shipxAgencyMappings.resetAction({ actionType: 'create' }))
      await dispatch(shipxAgencyMappings.create({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/shipx-cloud/shipx-agency-mappings`,entity:'dbnpMappings',jsonData:{
          
        "Context": {},    
        "Records": [
            selectedDbaMapping
        ]
    
  }})).then(()=>{
    back()
  })
  
    } 
  }


  useEffect(() => {
     const matchedItem = dbnpItems?.result?.items.find(
      (item: any) => item.Id === selectedDbaMapping?.PartnerDBNPRegistryId
    );
    if (selectedDbaMapping?.PartnerDBNPRegistryId) {
          dispatch(globalDBARegistries.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn/global-dba-registries/fetch`,entity:'globalDBARegistries',jsonData:{
               "Context": {},
  "Records" : [{
    "DBNPId" : matchedItem?.DBNPId,
  }],
          }}))
    }
  }, [selectedDbaMapping?.PartnerDBNPRegistryId]);

const back=()=>{
  navigate('/management/shipx-cloud/shipx-agency-mappings')
} 

    return (
    <>
     {isLoading ? <PageLoader /> : 
          <DbaMappingComponent 
           id={parmas.id}
           onFormChange={handleInnerFormChange}
           dbnp ={dbnpItems?.result?.items }
           selectedDbaMapping={selectedDbaMapping}
           dbnps={dbnpregistriesItems?.result?.items}
           channelPrograms={itemsData?.result?.items}
           back={back}
           handleFormSubmit={handleFormSubmit}
           dbas={dbasItems?.result?.items}
           dodProgramParticipants={participantsData?.result?.items}
          /> 
        } 
          </>
    )
    
    }
   
    export default ShipXAgencyMapping;